export const TYPES = {
  SyncStateRepository: Symbol.for('SyncStateRepository'),
};
